export { processCounts } from "./ProcessCountsReducer";
export { processCount, processes, referencedProcessMap, usedInProcessesMap, usedProcessesMap, logRetentionUsage, logLevelUsage } from "./ProcessReducer";
export { drafts } from "./DraftReducer";
export { availableTags } from "./AvailableTagsReducer";
export { listState } from "./ListStateReducer";
export { agentGroups, currentAgentGroupName } from "./AgentGroupReducer";
export { deployDialogState } from "./DeployDialogStateReducer";
export { loading } from "./LoadingReducer";
export { agentStatuses } from "./AgentStatusReducer";
export { runOnceDialogState } from "./RunOnceDialogStateReducer";
export { logLevelDialogState } from "./LogLevelDialogReducer";
export { tasks } from "./TaskReducer";
export { confirmDeleteDialogState } from "./ConfirmDeleteDialogStateReducer";
export { cleanOldVersionsDialogState } from "./CleanOldVersionsDialogStateReducer"
export { processVariablesEditorState } from "./ProcessVariablesEditorModalReducer";
export { environmentVariables } from "./EnvironmentVariablesReducer";

/** Identity just so the const can be stored to the store TODO: wrap all UI state to its own substate? */
export const isSubprocessList = (state = false) => state;
export const userPermissions = (state = {}) => state;
